import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './scholarshipblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchScholarshipInfo } from '../../../services/api'; // Новая функция

const ScholarshipBlock = () => {
    const { settings } = useAccessibility();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchScholarshipInfo();
                // Данные теперь в response.data[0].attributes
                setData(response.data[0].attributes);
                console.log('Scholarship data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching scholarship data:', err);
                setError('Не удалось загрузить данные. Пожалуйста, попробуйте позже.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // File link component
    const FileLink = ({ file, label, fallbackUrl, fallbackExt }) => {
        if (file?.data?.attributes?.url) {
            return (
                <Link
                    href={`${file.data.attributes.url}`}
                    children={`${label} (${file.data.attributes.ext || 'PDF'})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        if (fallbackUrl) {
            return (
                <Link
                    href={fallbackUrl}
                    children={`${label} (${fallbackExt})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        return null;
    };

    if (loading) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>Загрузка данных...</p>
            </Block>
        );
    }

    if (error) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>{error}</p>
            </Block>
        );
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='СТИПЕНДИИ И МЕРЫ ПОДДЕРЖКИ ОБУЧАЮЩИХСЯ'
            headerColor={textColor}
            id='scholarship'
            aria-label="Стипендии и меры поддержки обучающихся"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Scholarships Section */}
                        <section aria-labelledby="scholarships">
                            <h4 id="scholarships" className={style.header} style={{ color: textColor }}>
                                Стипендии обучающимся
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                {data?.Description ? (
                                    data.Description.split('. ').map((sentence, index) => (
                                        <p key={index}>{sentence.trim() + (sentence.endsWith('.') ? '' : '.')}</p>
                                    ))
                                ) : (
                                    <>
                                        <p>Стипендии обучающимся не предоставляются.</p>
                                        <p>Образовательная организация не предоставляет обучающимся стипендии, материальную помощь и другие виды денежных выплат, так как не предусмотрено законодательством Российской Федерации для организаций, осуществляющих спортивную подготовку.</p>
                                    </>
                                )}
                            </div>
                        </section>

                        {/* Social Support Section */}
                        <section aria-labelledby="social-support">
                            <h4 id="social-support" className={style.header} style={{ color: textColor }}>
                                Меры социальной поддержки
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>Обучающимся предоставляются следующие меры поддержки:</p>
                                {data?.Support && data.Support.length > 0 ? (
                                    <ul className={style.list}>
                                        {data.Support.map((item) => (
                                            <li key={item.id}>{item.Item}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <ul className={style.list}>
                                        <li>обеспечение питанием</li>
                                        <li>обеспечение спортивной экипировкой</li>
                                        <li>обеспечение проезда к месту проведения спортивных мероприятий и обратно</li>
                                        <li>обеспечение проживания в период проведения спортивных мероприятий</li>
                                        <li>осуществление медицинского обеспечения лиц, проходящих спортивную подготовку, в том числе организация систематического медицинского контроля</li>
                                    </ul>
                                )}
                                <FileLink 
                                    file={data?.EquipmentFile}
                                    label="Перечень спортивной экипировки"
                                    fallbackUrl="https://drive.google.com/file/d/1ShqNy5R8Uk47xgU-5mr9gYWP8uR6T9j6/view?usp=sharing"
                                    fallbackExt="PDF"
                                />
                            </div>
                        </section>

                        {/* Hostel Section */}
                        <section aria-labelledby="hostel-info">
                            <h4 id="hostel-info" className={style.header} style={{ color: textColor }}>
                                Общежитие для иногородних обучающихся
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>Образовательная организация не предоставляет общежитие для иногородних обучающихся.</p>
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
};

export default ScholarshipBlock;